import T, { t } from '../../common/components/T';
import { rolesMenu } from '../../common/utils/utils';

const itemMenuChild = (submenu, data, lang) => {
    const accum = [];
    if (!!submenu.length) {
        submenu.map((childItem) => {
            const id = childItem._id;
            const childrenData = [];
            data.map((itemData) => {
                if (itemData.parent === id) {
                    childrenData.push(itemData);
                }
            });

            accum.push({
                ...childItem,
                title: childItem.title[lang] || childItem.title.default,
                icon: childItem.icon || (childItem.type === 'part' ? 'menu-category' : 'menu-file'),
                name: childItem._id + '-name',
                asLink: !!childItem.link ? childItem.link : childItem._id + '_link',
                submenu: itemMenuChild(childrenData, data, lang)
            });
        });
    }
    return accum;
};

export const getItemMenu = (data, roles, lang, outerPart, translation, profileData, waitForProfileData) => {
    const menu = [];
    if (waitForProfileData && !profileData) return menu;
    if (data && !!data?.length && roles && roles?.length) {
        const filtered = rolesMenu(data, roles, profileData);
        const sorted = filtered.sort((a, b) => a.order - b.order);
        const parent = sorted.find((element) => element.parent === '')?._id;

        sorted.map((item) => {
            if (item.parent === parent) {
                const id = item._id;
                const submenu = [];
                sorted.map((itemChild) => {
                    if (itemChild.parent === id) {
                        submenu.push(itemChild);
                    }
                });

                menu.push({
                    ...item,
                    title: item.title[lang] || item.title.default,
                    icon: item.icon,
                    name: item._id + '-name',
                    submenu: itemMenuChild(submenu, sorted, lang),
                    asLink: !!item.link ? item.link : item._id + '_link'
                });
            }
        });
    } else {
        return menu;
    }
    if (outerPart) {
        menu.push({
            _id: 'logout',
            activity: true,
            asLink: '/logout',
            icon: 'menu-logout',
            name: 'logout',
            roles: [],
            showAll: true,
            target: false,
            type: 'link',
            linkNative: 'Home',
            title: translation ? (
                t('logoutTitle', 'Выйти', 'all', translation)
            ) : (
                <T textName='logoutTitle' defaultStr='Выйти' page='all' />
            ),
            submenu: []
        });
    }
    return menu;
};
